import { useMemo } from 'react';
import { Carousel } from 'foundations-components/transitional/components/Carousel';
import SingleStepContent from './SingleStepContent';
import { jsx as _jsx } from "react/jsx-runtime";
const CoachingTipSteps = ({
  steps,
  onStepChange
}) => {
  const singleStep = steps && steps.length === 1;
  const stepsWithAlt = useMemo(() => steps.map(step => Object.assign({}, step, {
    alt: ''
  })), [steps]);
  if (singleStep) {
    return /*#__PURE__*/_jsx(SingleStepContent, {
      step: steps[0]
    });
  }
  return /*#__PURE__*/_jsx(Carousel, {
    "data-test-id": "coaching-tip-popover-carousel",
    steps: stepsWithAlt,
    onStepIndexChange: onStepChange,
    marginBlockStart: "500"
  });
};
export default CoachingTipSteps;